<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Report Definitions
      <div slot="right">
        <b-button
          v-if="isEditAllowed"
          type="is-normal import-button"
          @click="clickAddReportDefinition('', true)"
          >+ &nbsp;Copy Report Definition</b-button
        >
        <b-button
          v-if="isEditAllowed"
          type="is-primary import-button"
          @click="clickAddReportDefinition"
          >+ &nbsp;Add Report Definition</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <circul8-table
        :records="data"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :isCheckable="true"
        :showRemoveButton="isEditAllowed"
        :showEditButton="true"
        :routeNext="false"
        :maxTextLength="'24'"
        :isLoading="isDataLoading"
        :backendSortingEnabled="true"
        @backendSort="sortData"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        @clickDelete="deleteModal"
        @clickEdit="clickEditReportDefinition"
        @clickView="clickViewReportDefinition"
        :saveDataFields="true"
        :tableName="tblName"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + data.length
                : totalRecords
              : data.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
    <add-report-definition
      :is-active="isModalActive"
      :view-only="viewOnly"
      :action="action"
      :form="editObjectName"
      :is-copy="isCopy"
      @confirm="addReportDefinition"
      @cancel="editCancel"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import Circul8Table from "../../components/Circul8Table.vue";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import AddReportDefinition from "@/components/RulesManager/AddReportDefinition.vue";
import CountryDataService from "@/services/CountryDataService";
import ContainerDataService from "@/services/ContainerDataService";
import SchemeDataService from "@/services/SchemeDataService";
import { UserGroup } from "@/services/UserGroups";
import * as dayjs from "dayjs";

export default {
  name: "ReportDefinitions",
  mixins: [UtilityMixin, ScopeMixin],
  components: { HeroBar, TitleBar, Circul8Table, AddReportDefinition },
  data() {
    return {
      tblName: "ReportDefinitions",
      data: [],
      isDataLoading: false,
      isModalActive: false,
      isTabularModalActive: false,
      isCategoryModalActive: false,
      invalidCategories: null,
      action: null,
      isAdd: false,
      editObject: this.getClearFormObject(),
      viewOnly: false,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: true,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      categories: [],
      scopeData: [],
      isCopy: false,
      columns: [
        {
          field: "country_name",
          label: "Country",
          searchable: true,
          searchKey: "country_name",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: this.countries,
          filterKey: { country_name: "", field_name: "name" }
        },

        {
          field: "scheme_name",
          label: "Scheme",
          type: "multiSelectFilter",
          searchable: true,
          filterKey: { scheme_name: "", field_name: "name" },
          allStatusVals: this.schemes,
          searchKey: "scheme_name"
        },
        {
          field: "stream_name",
          label: "Stream",
          searchable: true,
          type: "multiSelectFilter",
          filterKey: { stream_name: "", field_name: "name" },
          initStatusVals: [],
          allStatusVals: this.containers,
          searchKey: "stream_name"
        },
        {
          field: "report_type",
          label: "Report Type",
          searchable: true,
          type: "input",
          filterKey: { report_type: "" }
        },
        {
          field: "valid_from",
          label: "Valid From",
          searchable: true,
          filterKey: { valid_from: "" },
          type: "dateField"
        },
        {
          field: "valid_to",
          label: "Valid To",
          searchable: true,
          filterKey: { valid_to: "" },
          type: "dateField"
        },
        {
          field: "is_tabular",
          label: "Tabular",
          searchable: true,
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [{ name: "Yes" }, { name: "No" }],
          filterKey: {
            is_tabular: [],
            field_name: "name"
          }
        },
        {
          field: "status",
          label: "Status",
          searchable: true,
          visible: true,
          searchKey: "status",
          type: "multiSelectFilter",
          multiSelectFilter: true,
          initStatusVals: [],
          allStatusVals: [
            { name: "Draft" },
            { name: "Sent for Approval" },
            { name: "Approved" },
            { name: "Rejected" }
          ],
          filterKey: {
            status: [],
            field_name: "name"
          }
        },
        {
          field: "updated_at",
          label: "Last Updated",
          searchable: true,
          filterKey: { updated_at: "" },
          type: "dateField"
        },
        {
          field: "updated_by_name",
          label: "Updated By",
          searchable: true,
          filterKey: { updated_by_name: "" },
          type: "input"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      RulesManagerService: new RulesManagerService(),
      containerDataService: new ContainerDataService(),
      countryDataService: new CountryDataService(),
      schemeDataService: new SchemeDataService()
    };
  },
  mounted() {
    this.fetchCountries();
    this.checkExternalPermission();
    this.fetchContainers();
    this.fetchSchemes();
    if (localStorage.getItem(this.tblName + "SaveDataFields")) {
      this.columns = JSON.parse(
        localStorage.getItem(this.tblName + "SaveDataFields")
      );
      // convert date string to object to auto populate in filter for date
      this.convertDateStringToObject();
    }
    if (localStorage.getItem(this.tblName + "Query")) {
      this.query = `${localStorage.getItem(this.tblName + "Query")}&`;
    }
    this.fetchReportDefinitionsData(this.query);
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rule Manager" },
        { url: "/ruleManager/reportDefinitions", name: "Report Definitions" }
      ];
    },
    isEditAllowed() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    convertDateStringToObject() {
      const valid_from = this.find_column_index("valid_from");
      if (this.columns[valid_from].filterKey.valid_from.length) {
        this.columns[valid_from].filterKey.valid_from[0] = new Date(
          this.columns[valid_from].filterKey.valid_from[0]
        );
        this.columns[valid_from].filterKey.valid_from[1] = new Date(
          this.columns[valid_from].filterKey.valid_from[1]
        );
      }

      const valid_to = this.find_column_index("valid_to");
      if (this.columns[valid_to].filterKey.valid_to.length) {
        this.columns[valid_to].filterKey.valid_to[0] = new Date(
          this.columns[valid_to].filterKey.valid_to[0]
        );
        this.columns[valid_to].filterKey.valid_to[1] = this.convertToDateObject(
          this.columns[valid_to].filterKey.valid_to[1]
        );
      }

      const updated_at = this.find_column_index("updated_at");
      if (this.columns[updated_at].filterKey.updated_at.length) {
        this.columns[updated_at].filterKey.updated_at[0] = new Date(
          this.columns[updated_at].filterKey.updated_at[0]
        );
        this.columns[
          updated_at
        ].filterKey.updated_at[1] = this.convertToDateObject(
          this.columns[updated_at].filterKey.updated_at[1]
        );
      }
    },
    convertToDateObject(date) {
      if (date) {
        return new Date(date);
      }
    },
    getClearFormObject() {
      return {
        id: null,
        country: null,
        scheme: null,
        stream: null,
        report_type: null,
        report_definition: null,
        valid_from: null,
        valid_to: null
      };
    },

    clickAddReportDefinition(formData = this.getClearFormObject, copyClicked) {
      if (formData.valid_from != null) {
        formData.valid_from = new Date(formData.valid_from);
        formData.valid_to = new Date(formData.valid_to);
      }
      this.isCopy = copyClicked;
      this.viewOnly = false;
      this.action = copyClicked ? "Copy" : "Add";
      this.isAdd = true;
      this.editObject = formData;
      this.isModalActive = true;
    },
    reportDefintionView(categories, formData) {
      categories.forEach(e => (e.rules = []));
      formData.valid_from_old = formData.valid_from;
      formData.valid_to_old = formData.valid_to;
      if (formData.is_tabular_report) {
        this.$router
          .push({
            name: "rulesManager.tabularReportDefinition",
            params: {
              formData,
              isAdd: true,
              isViewOnly: false,
              categories: categories,
              scopeData: this.scopeData
            }
          })
          .catch(err => {
            // Ignore navigation duplicate errors
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      } else {
        if (this.isCopy) {
          this.$router
            .push({
              name: "rulesManager.reportDefinition.copy",
              params: {
                formData,
                isAdd: true,
                isViewOnly: false,
                categories: categories,
                scopeData: this.scopeData
              }
            })
            .catch(err => {
              if (err.name !== "NavigationDuplicated") {
                throw err;
              }
            });
        } else {
          this.$router
            .push({
              name: "rulesManager.reportDefinition",
              params: {
                formData,
                isAdd: true,
                isViewOnly: false,
                categories: categories,
                scopeData: this.scopeData
              }
            })
            .catch(err => {
              if (err.name !== "NavigationDuplicated") {
                throw err;
              }
            });
        }
      }
    },
    addReportDefinition(formData) {
      this.fetchScopes(formData);
      this.RulesManagerService.getReportCategories(formData).subscribe(
        response => {
          this.categories = response;
          if (this.categories.invalid_categories) {
            let cat_fee_validity = "<ul>";
            const cat = this.categories.categories_fees;
            cat.forEach(function(item, index) {
              cat_fee_validity =
                cat_fee_validity + "<li><b>" + item.name + ":</b> ";
              if (item.valid_from) {
                cat_fee_validity += item.valid_from + " to " + item.valid_to;
              }

              const sub_categories = item.sub_categories;
              if (sub_categories.length > 0) {
                cat_fee_validity += "<ul>";
                sub_categories.forEach(function(subCategory) {
                  cat_fee_validity += "<li>";
                  cat_fee_validity += subCategory.name;
                  if (subCategory.valid_from) {
                    cat_fee_validity +=
                      " : " +
                      subCategory.valid_from +
                      " to " +
                      subCategory.valid_to;
                  }
                  cat_fee_validity += "</li>";
                });
                cat_fee_validity += "</ul>";
              }

              cat_fee_validity += "</li>";
            });
            cat_fee_validity += "</ul>";

            this.$buefy.dialog.confirm({
              canCancel: true,
              title:
                formData.valid_from +
                " to " +
                formData.valid_to +
                " does not match the validity of the categories.",
              message: cat_fee_validity,
              cancelText: "Cancel",
              confirmText: "Back",

              size: "is-medium",
              onCancel: () => this.editCancel(),
              onConfirm: () => this.clickAddReportDefinition(formData)
            });
          } else {
            this.reportDefintionView(this.categories.categories_fees, formData);
          }
        },
        e => {
          alert(
            "Could not fetch the valid reporting categories with the selected date range!"
          );
          this.clickAddReportDefinition(formData);
        }
      );
    },

    fetchScopes(formData) {
      this.RulesManagerService.getFilterScopeData(formData).subscribe(
        response => {
          this.scopeData = response.results;
        }
      );
    },
    editCancel() {
      this.editObject = {};
      this.isModalActive = false;
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        // Only transform if not already a string (to avoid double-transformation when merging data from multiple pages)
        if (typeof reportData["is_tabular"] !== "string") {
          reportData["is_tabular"] = reportData["is_tabular"] ? "Yes" : "No";
        }
        reportData["active"] = reportData["active"] ? "Active" : "Deactive";
        reportData["actions"] = data[report]["active"] && this.isEditAllowed;
        reportData["delete"] = data[report]["active"] && this.isEditAllowed;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        this.data.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.data = dataList;
      }
      this.isDataLoading = false;
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          "&" + query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchReportDefinitionsData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = "&" + query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query =
          "&" + query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchReportDefinitionsData(this.query, "prev");
    },
    searchByFilter(filterQuery) {
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      this.query = "&" + filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchReportDefinitionsData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.data = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn;
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder;
      const newOrderField = "&order_field" + "=" + field;
      const newOrderValue = "&order_by" + "=" + order;

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchReportDefinitionsData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    fetchReportDefinitionsData(query = "", scrollDir) {
      this.isDataLoading = true;
      this.RulesManagerService.getReportDefinitionData(query).subscribe(
        response => {
          this.columns[0].allStatusVals = this.countries;
          this.columns[1].allStatusVals = this.schemes;
          this.columns[2].allStatusVals = this.containers;
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...this.data, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.data];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isDataLoading = false;
          this.isLoading = false;
          this.nextData = false;
        }
      );
    },
    deleteModal(editObject) {
      this.$buefy.dialog.confirm({
        title: "Deleting Report Definition",
        message:
          "Are you sure you want to <b>delete</b> this Report Definition?",
        confirmText: "Delete Report Definition",
        type: "is-danger",
        onConfirm: () => this.deleteReportDefinition(editObject)
      });
    },
    deleteReportDefinition(editObject) {
      try {
        this.RulesManagerService.deleteReportDefinition(editObject).subscribe(
          () => {
            this.$buefy.toast.open("Report Definition deleted!");
            this.data = [];
            this.fetchReportDefinitionsData(this.query);
          },
          e => {
            console.log(e);
            this.isDataLoading = false;
          }
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error !",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    clickEditReportDefinition(editObject) {
      if (editObject.is_tabular == true || editObject.is_tabular == "Yes") {
        this.$router.push({
          path: `/rulesManager/tabularReportDefinition/${editObject.id}`
        });
      } else {
        this.$router.push({
          path: `/rulesManager/reportDefinition/${editObject.id}`
        });
      }
    },
    clickViewReportDefinition(editObject) {
      if (editObject.is_tabular == true || editObject.is_tabular == "Yes") {
        this.$router.push({
          path: `/rulesManager/tabularReportDefinition/${editObject.id}/view`
        });
      } else {
        this.$router.push({
          path: `/rulesManager/reportDefinition/${editObject.id}/view`
        });
      }
    }
  }
};
</script>
